export default __webpack_public_path__ + "static/media/support.4fdc3299.png";